import type { BlockSectionBg } from "./common/types";

export type TableTheme = {
  headline: string;
  caption: string;
  headerCell: string;
  bodyCell: string;
  tableTitle: string;
  tableTitleRow: string;
  tagVariant: "default" | "onTinted";
  rowInteractive: string;
  rowSelected: string;
};

/** Figma block_table 2462:2857 — lite, grey (muted), dark, red. */
const tableThemeMap: Record<BlockSectionBg, TableTheme> = {
  light: {
    headline: "text-foreground",
    caption: "text-tag-foreground",
    headerCell: "text-tag-foreground",
    bodyCell: "text-foreground",
    tableTitle: "text-foreground",
    tableTitleRow: "bg-muted",
    tagVariant: "default",
    rowInteractive: "desktop:hover:bg-muted",
    rowSelected: "bg-muted",
  },
  default: {
    headline: "text-foreground",
    caption: "text-tag-foreground",
    headerCell: "text-tag-foreground",
    bodyCell: "text-foreground",
    tableTitle: "text-foreground",
    tableTitleRow: "bg-muted",
    tagVariant: "default",
    rowInteractive: "desktop:hover:bg-muted",
    rowSelected: "bg-muted",
  },
  muted: {
    headline: "text-foreground",
    caption: "text-tag-foreground",
    headerCell: "text-tag-foreground",
    bodyCell: "text-foreground",
    tableTitle: "text-foreground",
    tableTitleRow: "bg-background",
    tagVariant: "default",
    rowInteractive: "desktop:hover:bg-background",
    rowSelected: "bg-background",
  },
  dark: {
    headline: "text-secondary-foreground",
    caption: "text-header-top-fg",
    headerCell: "text-header-top-fg",
    bodyCell: "text-secondary-foreground",
    tableTitle: "text-secondary-foreground",
    tableTitleRow: "bg-header-top-fg/10",
    tagVariant: "onTinted",
    rowInteractive: "desktop:hover:bg-header-top-fg/10",
    rowSelected: "bg-header-top-fg/15",
  },
  red: {
    headline: "text-primary-foreground",
    caption: "text-header-top-fg",
    headerCell: "text-header-top-fg",
    bodyCell: "text-primary-foreground",
    tableTitle: "text-primary-foreground",
    tableTitleRow: "bg-primary-foreground/10",
    tagVariant: "onTinted",
    rowInteractive: "desktop:hover:bg-primary-foreground/10",
    rowSelected: "bg-primary-foreground/15",
  },
};

export function resolveTableTheme(sectionBg: BlockSectionBg): TableTheme {
  return tableThemeMap[sectionBg] ?? tableThemeMap.light;
}
